import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from 'formik';
import * as yup from 'yup';
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import _ from "lodash";
import { Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const MainCategory = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([])
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [active, setActive] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [isLoader, setIsLoader] = useState(false); //loader

const validationSchema = yup.object({
  category : yup.string().required(),
})

const formik = useFormik({
  initialValues :{
    category : ""
  },
  validationSchema:validationSchema,
onSubmit: isEdit ? handleUpdate : handleCreate
})

const onCreate = ()=>{
setOpen(true)
formik.resetForm()
setIsEdit(false)
}

function handleCreate(){
  const catData = {
    category_name: formik.values.category,
    category_image: null,
    is_active : active
  }
  setIsLoader(true);
  axios.post('/v1/categories', catData)
  .then(res=>{
    setOpen(false)
    getCategoryData()
    dispatch(setSnackbar(true, 'success', 'Created Successfully'))
    setIsLoader(false);
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
    console.log(err)
    setIsLoader(false);
  })
}

function onEdit(e){
console.log(e)
formik.setFieldValue('category',e.categoryName)
setIsEdit(true)
setOpen(true)
setActive(e.isActive)
setActiveId(e.id)
}

function handleUpdate(){
  const catData = {
    category_name: formik.values.category,
    category_image: null,
    is_active : active
  }
  setIsLoader(true);
  axios.put(`/v1/categories/${activeId}`, catData)
  .then(res=>{
    setOpen(false)
    console.log(res)
    getCategoryData()
    dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
    setIsLoader(false);
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
    console.log(err)
    setIsLoader(false);
  })
console.log('update')
}

function OnDelete(id){
  setOpenDialog(true)
  setActiveId(id)
}  

const handleDelete = () =>{
  setIsLoader(true);
  axios.delete(`/v1/categories/${activeId}`)
  .then(res=>{
    setOpenDialog(false)
    getCategoryData()
    console.log(res)
    dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
    setIsLoader(false);
    setOpen(false)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
    console.log(err)
    setIsLoader(false);
  })
console.log('fasdf')
}

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "categoryName",
      headerName: "Main Category Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      flex: 1,
      disableExport: true ,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
            <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
        </div>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      disableExport: true ,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data,(val,idx)=>({
    id: val.id,
    sno:++idx,
    isActive: val.is_active,
    categoryName : val.category_name
  }))

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch : setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };

const getCategoryData = () =>{
  const url = `/v1/categories/${rowsPerPage}/${page + 1}`
  const searchUrl = `/v1/categories/${rowsPerPage}/${page + 1}/${search}`
  setIsLoader(true);
  axios.get(search === '' ? url : searchUrl)
  .then(res=>{
    setData(res.data.data)
    setPageCount(res.data.meta.pagination.total)
    setIsLoader(false);
  })
  .catch(err=>{
    console.log(err)
    dispatch(setSnackbar(true, 'error', err.response.data.error))
    setIsLoader(false);
  })
}

useEffect(()=>{
getCategoryData()

},[rowsPerPage, page, search])

  return (
    <Fragment>
      <Helmet>
        <title>Main Category</title>
      </Helmet>
      <Typography variant="h5">Main Category</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
        <Modal onClose={setOpen}  onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='category' value={formik.values.category} title='Main Category' multiple={false} placeholder='Enter Main Category' onchange={formik.handleChange} errorMsg={formik.touched.category && Boolean(formik.errors.category)} helperText={formik.touched.category && formik.errors.category}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader}/> */}
    </Fragment>
  );
};

export default MainCategory;
